require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-wilbert.json") })
        }
      }, "path---brand-design-wilbert");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-wilbert!./.cache/json/brand-design-wilbert.json
// module id = 382
// module chunks = 231608221292675